/**
 * Strings of «Додати об'єкт» (iteration 2, D5): inverters by SN → parameters
 * of each object and the common region and tariff → access for Phage.Energy.
 * Merged into `MESSAGES` (messages.ts); Ukrainian defines the key set.
 * No outage reserve in the object form: it is set in the object's settings.
 */
export const ONBOARDING_MESSAGES = {
  en: {
    'add.crumb': 'New object',
    'add.title': 'Add object',
    'add.steps': 'Steps',
    'add.step.inverters': 'Inverters',
    'add.step.params': 'Parameters',
    'add.s1.title': 'Inverters',
    'add.s1.sub':
      'The SN from the sticker on the inverter. You can add several. No DeyeCloud sign-in: we find the inverter once you open the access for Phage.Energy.',
    'add.sn': 'Inverter SN',
    'add.sn_more': 'Add one more SN',
    'add.sn_remove': 'Remove',
    'add.sn_empty': 'Enter the SN from the inverter sticker.',
    'add.connected': 'already connected',
    'add.inverter': 'Inverter {sn}',
    'add.next_n': 'Next · {n} SN',
    'add.s3.title': 'Parameters',
    'add.s3.sub': 'Filled from DeyeCloud — correct them if needed. Choose the tariff and what was not found.',
    'add.src.deye': 'from DeyeCloud',
    'add.src.manual': 'set by hand',
    'add.pv': 'Solar plant',
    'add.err.region': 'Choose the region.',
    'site.pick_tariff': 'Choose the tariff — then internal arbitrage can be switched on.',
    'site.params_missing': 'Enter the battery capacity and the inverter power in the settings.',
    'site.to_settings': 'Settings',
    'add.app_name': 'Name in the app',
    'add.common': 'Region and tariff',
    'add.note':
      'Next — open the access for Phage.Energy in DeyeCloud. Until then we read and change nothing. With the access we save the current inverter settings and change nothing until you switch internal arbitrage on.',
    'add.connect.one': 'Connect object',
    'add.connect.few': 'Connect {n} objects',
    'add.connect.many': 'Connect {n} objects',
    'add.connect.other': 'Connect {n} objects',
    'add.done.one': 'Object connected — now open the access for Phage.Energy.',
    'add.done.few': '{n} objects connected — now open the access for Phage.Energy.',
    'add.done.many': '{n} objects connected — now open the access for Phage.Energy.',
    'add.done.other': '{n} objects connected — now open the access for Phage.Energy.',
    'add.err.taken': 'Already connected: SN {sn}.',
    'add.err.rates':
      'The objects are connected, but the zone rates were not saved — enter them in the settings.',
  },
  uk: {
    'add.crumb': "Новий об'єкт",
    'add.title': "Додати об'єкт",
    'add.steps': 'Кроки',
    'add.step.inverters': 'Інвертори',
    'add.step.params': 'Параметри',
    'add.s1.title': 'Інвертори',
    'add.s1.sub':
      'SN з наклейки на інверторі. Можна додати кілька. Вхід у DeyeCloud не потрібен: інвертор знайдемо, коли ви відкриєте доступ для Phage.Energy.',
    'add.sn': 'SN інвертора',
    'add.sn_more': 'Додати ще один SN',
    'add.sn_remove': 'Прибрати',
    'add.sn_empty': 'Введіть SN з наклейки інвертора.',
    'add.connected': 'вже підключено',
    'add.inverter': 'Інвертор {sn}',
    'add.next_n': 'Далі · {n} SN',
    'add.s3.title': 'Параметри',
    'add.s3.sub': 'Заповнено з DeyeCloud — за потреби виправте. Оберіть тариф і те, що не визначилося.',
    'add.src.deye': 'з DeyeCloud',
    'add.src.manual': 'вручну',
    'add.pv': 'СЕС',
    'add.err.region': 'Оберіть область.',
    'site.pick_tariff': 'Оберіть тариф — тоді можна ввімкнути внутрішній арбітраж.',
    'site.params_missing': 'Вкажіть ємність батареї й потужність інвертора в «Налаштуваннях».',
    'site.to_settings': 'Налаштування',
    'add.app_name': 'Назва в застосунку',
    'add.common': 'Область і тариф',
    'add.note':
      'Далі — відкрийте доступ для Phage.Energy у DeyeCloud. Поки доступу немає, ми нічого не читаємо й не змінюємо. Після доступу збережемо поточні налаштування інверторів і нічого не змінимо, доки ви не ввімкнете внутрішній арбітраж.',
    'add.connect.one': "Підключити об'єкт",
    'add.connect.few': "Підключити {n} об'єкти",
    'add.connect.many': "Підключити {n} об'єктів",
    'add.connect.other': "Підключити {n} об'єкта",
    'add.done.one': "Об'єкт підключено — тепер відкрийте доступ для Phage.Energy.",
    'add.done.few': "Підключено {n} об'єкти — тепер відкрийте доступ для Phage.Energy.",
    'add.done.many': "Підключено {n} об'єктів — тепер відкрийте доступ для Phage.Energy.",
    'add.done.other': "Підключено {n} об'єкта — тепер відкрийте доступ для Phage.Energy.",
    'add.err.taken': 'Вже підключено: SN {sn}.',
    'add.err.rates': "Об'єкти підключено, але ставки зон не збережено — введіть їх у «Налаштуваннях».",
  },
} as const;
